import React from 'react';
import { Breadcrumb, Layout, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import buscarAntecedentes from '../../../graphql/querys/contravenciones/buscarAntecedentes.graphql';
import antecedentes from '../../../graphql/querys/contravenciones/antecedentes.graphql';
import getPersonaPorDocumento from '../../../graphql/querys/personas/getPersonaPorDocumento.graphql';

import FormAntecedentes from '../formularios/FormAntecedentes';
import ModalBuscarAntecedentes from './ModalBuscarAntecedentes';

import Loading from '../../common/Loading';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

class BuscarAntecedentes extends React.Component {
  state = {
    persona: {},
    expedientesAntecedentes: [],
    expedientesAntecedentesExternos: [],
    mostrarModalAntecedentes: false,
    loading: false,
  };

  buscarPersona = values => {
    // console.log('Buscar Persona con =>', values);
    this.setState({
      ...this.state,
      loading: true,
    });

    this.props.client
      .query({
        query: getPersonaPorDocumento,
        variables: {
          tipo_doc: values.tipo_doc,
          num_doc: values.num_doc,
        },
      })
      .then(res => {
        if (res.data.getPersonaPorDocumento) {
          // console.log('Respuesta get persona =>');
          // console.log(res.data.getPersonaPorDocumento);

          this.setState({
            ...this.state,
            persona: res.data.getPersonaPorDocumento,
          });
          this.buscarAntecedentes(values);
        } else {
          notification.error({
            message: 'No se encontró a  la persona',
          });
        }
        this.setState({
          ...this.state,
          loading: false,
        });
      })
      .catch(err => {
        console.error('Error en la busqueda de persona', err);
        this.setState({
          ...this.state,
          loading: false,
        });
      });
  };

  buscarAntecedentes = values => {
    // console.log('los values son =>', values);

    this.setState({
      ...this.state,
      loading: true,
    });
    this.props.client
      .query({
        query: buscarAntecedentes,
        variables: {
          tipo_doc: values.tipo_doc,
          num_doc: values.num_doc,
        },
      })
      .then(respuesta => {
        if (respuesta.data.buscarAntecedentes) {
          // console.log('Respuesta BUSCARON: ');
          // console.log(respuesta.data.buscarAntecedentes);

          this.props.client
            .query({
              query: antecedentes,
              variables: {
                tipoDoc: values.tipo_doc,
                numDoc: values.num_doc,
              },
            })
            .then(res => {
              // console.log('RECIBI RESPUESTA EXTERNA: ', res);

              notification.info({
                message: 'Busqueda realizada con exito.',
              });

              let exp = [];
              let expedientes = respuesta.data.buscarAntecedentes;
              expedientes.forEach(element => {
                exp.push(element);
              });

              this.setState({
                expedientesAntecedentes: exp,
                expedientesAntecedentesExternos: res.data.antecedentes
                  ? res.data.antecedentes.antecedentes
                  : [],
                mostrarModalAntecedentes: true,
                loading: false,
              });
            })
            .catch(error => {
              console.log('error interno al buscar antecedentes: ', error);
              notification.error({
                message:
                  'Error al buscar los antecedentes dentro de Justicia de Paz',
              });

              this.setState({
                loading: false,
              });
            });
        } else {
          notification.error({
            message: 'No se encontraron Antecedentes',
          });
        }
      })
      .catch(err => {
        console.log('error en busqueda de antecedentes', err);
        notification.error({
          message:
            'Error al buscar los antecedentes externos a la Justicia de Paz',
        });
        this.setState({
          loading: false,
        });
      });
  };

  ocultarModalAntecendetes = () => {
    this.setState({
      mostrarModalAntecedentes: false,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Persona</Breadcrumb.Item>
          <Breadcrumb.Item>Buscar Antecedentes</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.SearchOutlined /> Buscar Antedecentes de Persona
          </h2>
          <br />
          <div style={estiloContent}>
            <FormAntecedentes
              onSubmit={this.buscarAntecedentes}
              buscarPersona={this.buscarPersona}
            />
          </div>
        </Layout>
        <ModalBuscarAntecedentes
          mostrarModalAntecedentes={this.state.mostrarModalAntecedentes}
          ocultarModalAntecendetes={this.ocultarModalAntecendetes}
          expedientes={this.state.expedientesAntecedentes}
          expedientesExternos={this.state.expedientesAntecedentesExternos}
          persona={this.state.persona}
        />
      </div>
    );
  }
}

export default withApollo(BuscarAntecedentes);
